import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { formatNumber } from '@debbie/common/dist';
import { AggregationType } from '@debbie/common/dist/insights/aggregations';
import { useAggregation } from '@debbie/cortex/dist/insights';
import PlaceholderLoader from '../PlaceholderLoader';
import Table from '../Table';
import CaseFilterQueue from './CaseFilterQueue';
import { h } from '@debbie/cortex/dist';
const AggregationComponent = (props) => {
    const { type, caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const aggregationLoadable = useAggregation(type, caseFilter);
    const aggregation = h.hasData(aggregationLoadable)
        ? aggregationLoadable.data
        : null;
    return (React.createElement("div", { style: {
            fontSize: '.7em',
            marginBottom: '20px',
            maxHeight: '389px',
            overflowY: 'scroll',
        } }, aggregation ? ((() => {
        switch (aggregation.type) {
            case AggregationType.CountAll:
                return (React.createElement("p", { style: {
                        margin: '0',
                        fontSize: '1.3em',
                    } },
                    React.createElement("b", null, typeof aggregation.aggregation.count === 'number'
                        ? formatNumber(aggregation.aggregation.count * 100).slice(0, -3)
                        : '-'),
                    ' ',
                    lang.caseFilter.casesSelected,
                    " ",
                    React.createElement(CaseFilterQueue, null)));
            case AggregationType.ByCaseGroup:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        title: row.label || '-',
                        count: row.count,
                        appendToCaseFilter: {
                            caseGroups: [row.caseGroupId],
                        },
                    })) }));
            case AggregationType.ByCreditor:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        link: `/creditors/${row.creditorId}`,
                        title: row.creditorName,
                        count: row.count,
                        appendToCaseFilter: {
                            creditorIds: [row.creditorId],
                        },
                    })) }));
            case AggregationType.ByWorkflow:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        link: row.workflowId
                            ? `/workflows/${row.workflowId}`
                            : undefined,
                        title: row.workflowTitle || '-',
                        count: row.count,
                        appendToCaseFilter: row.workflowId
                            ? {
                                inWorkflowIds: [row.workflowId],
                            }
                            : undefined,
                    })) }));
            case AggregationType.ByCaseStatus:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        // @ts-ignore
                        title: lang.cases[row.status],
                        count: row.count,
                        appendToCaseFilter: row.status
                            ? {
                                caseStatuses: [row.status],
                            }
                            : undefined,
                    })) }));
            case AggregationType.ByBillingModel:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        title: row.billingModelName || '-',
                        count: row.count,
                        appendToCaseFilter: row.billingModelId
                            ? {
                                billingModelIds: [row.billingModelId],
                            }
                            : undefined,
                    })) }));
            case AggregationType.ByBillingAppendixSetup:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        title: row.billingAppendixSetupName || '-',
                        count: row.count,
                        appendToCaseFilter: row.billingAppendixSetupId
                            ? {
                                billingAppendixSetupIds: [row.billingAppendixSetupId],
                            }
                            : undefined,
                    })) }));
            case AggregationType.ByMigratedWorkflowTaskId:
                return (React.createElement(AggregationTable, { data: aggregation.aggregation.map((row) => ({
                        title: row.taskId || '-',
                        count: row.count,
                        appendToCaseFilter: row.taskId
                            ? {
                                alternativeWorkflowPaths: [row.taskId],
                            }
                            : undefined,
                    })) }));
            default:
                return null;
        }
    })()) : (React.createElement(PlaceholderLoader, null))));
};
export default AggregationComponent;
const AggregationTable = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Table, { zebra: true, sumRow: true },
        props.data
            .sort((a, b) => b.count - a.count)
            .map((row) => (React.createElement("tr", { key: JSON.stringify(row) },
            React.createElement("td", { style: { paddingLeft: 0 }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${((row.count / props.data.reduce((acc, r) => acc + r.count, 0)) *
                    100).toFixed(2)} %` }, row.link ? (
            //@ts-ignore
            React.createElement(Link, { to: row.link, style: { color: 'inherit' } },
                React.createElement("div", { title: row.title, style: {
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px',
                    } }, row.title))) : (React.createElement("div", { title: row.title, style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                } }, row.title))),
            React.createElement("td", { style: { textAlign: 'right', paddingRight: 0 } },
                formatNumber(row.count * 100).slice(0, -3),
                ' ',
                row.appendToCaseFilter && (React.createElement(CaseFilterQueue, { appendToCaseFilter: row.appendToCaseFilter })))))),
        React.createElement("tr", null,
            React.createElement("td", { style: { paddingLeft: 0 } }, lang.caseFilter.aggregationSum),
            React.createElement("td", { style: { textAlign: 'right', paddingRight: 0 } },
                formatNumber(props.data.reduce((acc, r) => acc + r.count, 0) * 100).slice(0, -3),
                ' ',
                React.createElement(CaseFilterQueue, { appendToCaseFilter: {} })))));
};
//# sourceMappingURL=Aggregation.js.map